import React from "react";
import cn from "classnames";

import { HeadingProps } from "../Heading.props";
import styles from "./H3.module.scss";

/**
 * @deprecated
 */
const H3: React.FC<HeadingProps> = ({ children, id, testId, className, roboto, large, semiBold }: HeadingProps): JSX.Element => {
  const headerClasses = cn(
    styles["h3"],
    { [styles["roboto"]]: roboto },
    { [styles["large"]]: large },
    { "semi-bold": semiBold },
    className,
  );

  return (
    <h3 className={headerClasses} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </h3>
  );
};

/**
 * @deprecated
 */
export default H3;
